"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saleActivityPaymentFactory = exports.saleActivityCreatedFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
exports.saleActivityCreatedFactory = Factory.Sync.makeFactory({
    amount: Mocks.clare.amountNull,
    amount_outstanding: Mocks.clare.amountTen,
    created_at: Mocks.dates.date2000,
    label: 'Order Created',
    sale_transaction_id: null,
    significance: 'high'
});
exports.saleActivityPaymentFactory = Factory.Sync.makeFactory({
    amount: Mocks.clare.amountTenNegative,
    amount_outstanding: Mocks.clare.amountZero,
    created_at: Mocks.dates.date2000,
    label: 'Payment Received',
    sale_transaction_id: Mocks.clare.txnId,
    significance: 'high'
});
